import { render } from "./RegistrationDownload.vue?vue&type=template&id=0b586c90"
import script from "./RegistrationDownload.vue?vue&type=script&lang=js"
export * from "./RegistrationDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__